import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ADPResourceService, CustomFormControl, ListItem } from 'digital-core';
import { sortBy as _sortBy } from 'lodash';
import { EquipmentSearchService } from 'src/app/shared/equipment-search/equipment-search.service';
import { EssItemGroup } from 'src/app/shared/equipment-search/ess-item-group';
import { FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'pgh-deductible-lookup-device',
  templateUrl: './deductible-lookup-device.component.html',
  styleUrls: ['./deductible-lookup-device.component.scss'],
})
export class DeductibleLookupDeviceComponent implements OnInit {

  @Output() public formSubmitted = new EventEmitter<any>();
  deviceTypes: ListItem[];
  makes: ListItem[];
  models: ListItem[];
  selectedDeviceType: EssItemGroup;
  selectedMake = '';
  selectedModel = '';

  constructor(
    private resourceService: ADPResourceService,
    private equipmentSearchService: EquipmentSearchService
  ) { }

  ngOnInit() {
    this.deviceTypes = this.mapEnumToListItem(EssItemGroup);
  }

  public deductibleLookupForm = new FormGroup({
    deviceTypesSelect: new CustomFormControl('', [Validators.required]),
    makesSelect: new CustomFormControl(this.selectedMake, [Validators.required]),
    modelsSelect: new CustomFormControl(this.selectedModel, [Validators.required]),
  });

  mapEnumToListItem<T>(enumObj: T): ListItem[] {
    return Object.keys(enumObj).map((key) => ({
      Id: key, Key: key, Value: key, counter: ''
    }));
  }

  getEssItemGroupByName(name: string): EssItemGroup | undefined {
    return EssItemGroup[name as keyof typeof EssItemGroup];
  }

  getMakes() {
    this.models = null;
    this.selectedModel = null;
    this.deductibleLookupForm.controls['makesSelect'].reset();
    const selectedDeviceTypeValue = this.deductibleLookupForm.controls['deviceTypesSelect'].value;
    this.selectedDeviceType = this.getEssItemGroupByName(selectedDeviceTypeValue);
    this.equipmentSearchService.getManufacturers(this.selectedDeviceType).subscribe(result => {
      this.makes = result.map(x => new ListItem(x, x, x));
    });
  }

  getModels() {
    this.deductibleLookupForm.controls['modelsSelect'].reset();
    this.selectedMake = this.deductibleLookupForm.controls['makesSelect'].value;
    this.equipmentSearchService.getAllModels(this.selectedMake, this.selectedDeviceType).subscribe(result => {
      console.log(result);
      this.models = result.map(x => new ListItem(x, x, x));
    });
  }

  handleFormSubmitted() {
    // TODO: Call Deductible Lookup service with selected values.
    this.formSubmitted.emit('values');
  }

  getResource(title: string) {
    let resourceValue = this.resourceService.getViewResourceObject(title);
    return resourceValue;
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }

}
